import { Paper, Stack, Text, ThemeIcon } from "@mantine/core";
import type { ReactNode } from "react";

/** Consistent "nothing here" block: icon, one-line title, optional hint and action. */
export function EmptyState({
  icon,
  title,
  hint,
  action,
}: {
  icon: ReactNode;
  title: string;
  hint?: string | undefined;
  action?: ReactNode | undefined;
}) {
  return (
    <Paper withBorder p="lg" radius="md">
      <Stack align="center" gap={6} ta="center">
        <ThemeIcon variant="light" color="gray" size={44} radius="xl">
          {icon}
        </ThemeIcon>
        <Text fw={600}>{title}</Text>
        {hint && (
          <Text size="sm" c="dimmed" maw={460}>
            {hint}
          </Text>
        )}
        {action}
      </Stack>
    </Paper>
  );
}
